import { render, staticRenderFns } from "./DetailsPopUp.vue?vue&type=template&id=3aef6716"
import script from "./DetailsPopUp.vue?vue&type=script&lang=ts"
export * from "./DetailsPopUp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports